import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import NO_IMAGE_USER from "../../../assets/images/no-user.png";
import { Collapse, CollapseProps } from "antd";
import { formatDateStringToKorea, formatNumber } from "helpers/format";
import { LIST_OPTION_GENDER, LIST_OPTION_SALARY_TYPE, renderWorkingDays } from "helpers/constans";

registerLocale("en", en);
registerLocale("ko", ko);

const ApplicationInfo = ({ data }: any) => {
  const { t, i18n } = useTranslation();

  const [formatExpectWorkingPlace, setFormatExpectWorkingPlace] = useState([]);

  const items: CollapseProps["items"] = data?.experience?.length > 0 ? (
    data?.experience?.map((item: any, index: number) => {
      const startDate = formatDateStringToKorea(item?.startDate || "", "YYYY-MM-DD") || '';
      const endDate = formatDateStringToKorea(item?.endDate || "", "YYYY-MM-DD") || '';

      return {
        key: index,
        label:  `${item?.workplace} | ${item?.position} | ${startDate} ~ ${endDate}`,
        children: (
          <div>
            <Row className="">
              <Col md={6} lg={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Workplace")}</Label>
                  <div>{item?.workplace}</div>
                </div>
              </Col>
              <Col md={6} lg={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Position")}</Label>
                  <div>{item?.position}</div>
                </div>
              </Col>
  
              <Col md={6} lg={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Start Date")}</Label>
                  <div>{startDate}</div>
                </div>
              </Col>
              <Col md={6} lg={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("End Date")}</Label>
                  <div>{endDate}</div>
                </div>
              </Col>
              <Col md={12} lg={12}>
                <div className="mb-3">
                  <Label className="form-label">{t("Description")}</Label>
                  <div>{item?.description}</div>
                </div>
              </Col>
            </Row>
          </div>
        ),
      }
    })
  ): undefined;

  useEffect(() => {
    if(data?.preferredAddress?.length > 0) {
      const lstRegions = data?.preferredAddress?.filter((item: any) => (item?.region1 || item?.region2));
      setFormatExpectWorkingPlace(lstRegions)
    }
  }, [data?.preferredAddress])

  useEffect(() => {
    document.title = `${t("Job Post Info")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div
        className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative m-3"
        style={{
          border: "1px dashed var(--vz-primary)",
          borderRadius: "4px",
        }}
      >
        <span
          className="text-primary position-absolute fs-13 px-1"
          style={{
            backgroundColor: "var(--vz-secondary-bg)",
            top: "0px",
            transform: "translateY(-50%)",
          }}
        >
          {t("Job Seeker Info")}
        </span>
        <Row className="py-3 px-2">
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Photo")}</Label>
              <div className="d-flex gap-2">
                {data?.imageUrls?.map((i: any, index: number) => (
                  <div key={index} style={{ width: "100px", height: "100px" }}>
                    <img
                      src={i || NO_IMAGE_USER}
                      alt="noUser"
                      className="w-100 h-100"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = NO_IMAGE_USER;
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3">
              <Label className="form-label">{t("Nick Name")}</Label>
              <div className="cursor-pointer">{data?.nickname || "-"}</div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3">
              <Label className="form-label">{t("Full Name")}</Label>
              <div className="cursor-pointer">{data?.fullname || "-"}</div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3">
              <Label className="form-label">{t("Gender")}</Label>
              <div className="cursor-pointer">
                {t(
                  LIST_OPTION_GENDER?.find(
                    (item: any) => String(item?.value) === String(data?.gender)
                  )?.label || "-"
                )}
              </div>
            </div>
          </Col>

          <Col md={4} lg={4}>
            <div className="mb-3">
              <Label className="form-label">{t("Birthdate")}</Label>
              <div className="cursor-pointer">
                {data?.dateOfBirth
                  ? formatDateStringToKorea(data?.dateOfBirth, "YYYY-MM-DD")
                  : "-"}
              </div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3">
              <Label className="form-label">{t("Phone Number")}</Label>
              <div className="cursor-pointer">{data?.phoneNumber || "-"}</div>
            </div>
          </Col>
          <Col md={4} lg={4}>
            <div className="mb-3">
              <Label className="form-label">{t("Email")}</Label>
              <div className="cursor-pointer">{data?.email || "-"}</div>
            </div>
          </Col>
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Self Introduce")}</Label>
              <div className="cursor-pointer">{data?.introduce || "-"}</div>
            </div>
          </Col>
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Careers")}</Label>

              <div>
                {
                  data?.experience?.length > 0 ? (
                    <Collapse
                      defaultActiveKey={["0"]}
                      // onChange={onChange}
                      expandIconPosition={"end"}
                      items={items}
                    />
                  ) : "-"
                }
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div
        className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative m-3"
        style={{
          border: "1px dashed var(--vz-primary)",
          borderRadius: "4px",
        }}
      >
        <span
          className="text-primary position-absolute fs-13 px-1"
          style={{
            backgroundColor: "var(--vz-secondary-bg)",
            top: "0px",
            transform: "translateY(-50%)",
          }}
        >
          {t("Desired working conditions")}
        </span>
        <Row className="py-3 px-2">
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Expect Working Days")}</Label>
              <div
                className="cursor-pointer"
                style={{ textTransform: "capitalize" }}
              >
                {
                  data?.preferredDayNegotiable === true ? (
                    <>{t("Negotiable")}</>
                  ) : (
                    renderWorkingDays(data?.preferredDays)
                  )
                }
              </div>
            </div>
          </Col>
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Expect Working Time")}</Label>
              <div className="cursor-pointer">
                {
                  data?.preferredTimeNegotiable === true ? (
                    <>{t("Negotiable")}</>
                  ) : (
                    <>{data?.preferredTimeFrom} - {data?.preferredTimeTo}</>
                  )
                }
              </div>
            </div>
          </Col>
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Expect Start Date")}</Label>
              <div className="cursor-pointer">
                {data?.preferredStartDate
                  ? formatDateStringToKorea(data?.preferredStartDate)
                  : "-"}
              </div>
            </div>
          </Col>

          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Expect Salary")}</Label>
              {!data?.salaryNegotiable ? (
                <div className="cursor-pointer">
                  {formatNumber(data?.expectedSalary)} {("₩")} -{" "}
                  {
                    t(
                      LIST_OPTION_SALARY_TYPE?.find(
                        (item: any) => String(item?.value) === String(data?.salaryType)
                      )?.label || ""
                    )
                  }
                </div>
              ) : (
                <div>{t("Negotiable")}</div>
              )}
            </div>
          </Col>
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Expect working place")}</Label>
              <div className="d-flex gap-2 align-items-center">
                {formatExpectWorkingPlace?.length > 0 ? formatExpectWorkingPlace?.map((item: any, index: number) => (
                  <button
                    key={index}
                    type="button"
                    style={{ border: "unset" }}
                    className={`px-4 py-2 rounded-md ${"bg-primary text-white"}`}
                  >
                    {item?.region1} - {item?.region2}
                  </button>
                )): "-"}
              </div>
            </div>
          </Col>
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">
                {t("Preferred contact time")}
              </Label>
              <div className="cursor-pointer">
                {data?.contactTimeRange}
              </div>
            </div>
          </Col>
          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">
                {t("Preferred contact method")}
              </Label>
              <div className="cursor-pointer">
                {data?.contactMethod?.join(", ")}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default ApplicationInfo;
